export const PersonJSONLD: (props: {
  name: string;
  uniqueName: string;
  url: string;
  desc: string;
  likeCount: number;
  followCount: number;
  postCount: number;
  avatar: string;
}) => JSX.Element = (props) => {
  const { name, uniqueName, url, desc, likeCount, followCount, postCount, avatar } = props;
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Person',
          alternateName: uniqueName,
          description: desc,
          mainEntityOfPage: {
            '@id': url,
            '@type': 'ProfilePage',
          },
          name,
          identifier: {
            '@type': 'http://schema.org/PropertyValue',
            propertyID: 'Username',
            value: uniqueName,
          },
          image: {
            '@type': 'ImageObject',
            contentUrl: avatar,
          },
          interactionStatistic: [
            {
              '@type': 'InteractionCounter',
              interactionType: {
                '@type': 'https://schema.org/LikeAction',
              },
              userInteractionCount: likeCount,
            },
            {
              '@type': 'InteractionCounter',
              interactionType: {
                '@type': 'https://schema.org/FollowAction',
              },
              userInteractionCount: followCount,
            },
            {
              '@type': 'InteractionCounter',
              interactionType: {
                '@type': 'https://schema.org/WriteAction',
              },
              userInteractionCount: postCount,
            },
          ],
        }),
      }}
    ></script>
  );
};
